import useScrolled from 'hooks/useScrolled';
import PageSection from './PageSection';
import styles from './styles/LogoHeader.module.scss';
import TeamImage from 'components/TeamImage';
import { ReactNode } from 'react';
import cn from 'classnames';

export default function LogoHeader({
  alt,
  image,
  title,
  subTitle,
  subText,
  right
}: {
  alt: string;
  image?: string;
  title: ReactNode;
  subTitle?: string;
  subText?: ReactNode;
  right?: ReactNode;
}) {
  const isScrolled = useScrolled();

  return (
    <div className={cn(styles.Header, { [styles.Scrolled]: isScrolled })}>
      <PageSection className={styles.Container} fullWidth>
        <TeamImage src={image} alt={alt} className={styles.Logo} />
        <div>
          <div className={cn(styles.Title, typeof title === 'string' && title.length > 40 && styles.LongTitle)}>{title}</div>
          {subTitle && <div className={styles.SubTitle}>{subTitle}</div>}
          {subText && <div className={styles.SubText}>{subText}</div>}
        </div>
        {right && <div className={styles.Right}>{right}</div>}
      </PageSection>
    </div>
  );
}
